import { EMPTY_FUNDRAISING_DONATION_PRICING } from '@blocktickets/shared-utils'

export const getCartSectionIds = (cart) => {
  const sectionIds = new Set()
  const ticketLists = [
    ...(Array.isArray(cart?.tickets) ? cart.tickets : []),
    ...(Array.isArray(cart?.package_tickets) ? cart.package_tickets : []),
  ]

  ticketLists.forEach((ticket) => {
    const sectionId = String(
      ticket?.sectionId || ticket?.section_id || ''
    ).trim()
    if (sectionId) sectionIds.add(sectionId)
  })

  return [...sectionIds]
}

export const getCartFundraisingContext = (cart) => {
  const search = new URLSearchParams(window.location.search)
  const sessionParticipantUuid = sessionStorage.getItem(
    'fundraisingParticipantUuid'
  )
  const sectionIds = getCartSectionIds(cart)

  return {
    organizationUUID:
      cart?.event?.organization?.uuid ||
      cart?.event?.organizationUUID ||
      cart?.package?.organization?.uuid ||
      cart?.package?.organizationUUID ||
      cart?.flex_pack?.organization?.uuid ||
      cart?.flex_pack?.organizationUUID ||
      cart?.access_pass_template?.organization?.uuid ||
      cart?.access_pass_template?.organizationUUID,
    eventUUID: cart?.event?.uuid || cart?.eventUUID,
    packageUUID: cart?.package?.uuid,
    flexPackUUID: cart?.flex_pack?.uuid,
    accessPassTemplateUUID: cart?.access_pass_template?.uuid,
    sectionIds: sectionIds.length ? sectionIds.join(',') : undefined,
    participantUuid:
      search.get('participantUuid') ||
      search.get('participant') ||
      sessionParticipantUuid ||
      undefined,
  }
}

export const buildFundraisingPayload = (campaign, selection) => {
  const donationAmount = Number(selection?.donationAmount || 0)
  if (!campaign?.campaignUuid || donationAmount <= 0) return null

  const minimumAmount = Number(
    campaign?.donationRequirements?.minimumAmount || 0
  )
  if (
    campaign?.donationRequirements?.mandatory &&
    minimumAmount > 0 &&
    donationAmount < minimumAmount
  ) {
    return null
  }

  return {
    campaignUuid: campaign.campaignUuid,
    participantUuid: selection?.participantUuid || '',
    donationAmount,
    anonymous: Boolean(selection?.anonymous),
    donorMessage: selection?.donorMessage || '',
  }
}

export const buildPaymentIntentRequest = (
  cart,
  event,
  fundraisingPayload,
  guest
) => ({
  ip: cart.ipAddress,
  cartId: cart.id,
  carted: true,
  cartTickets: cart.tickets,
  totalFromCart:
    cart?.flex_pack || cart?.access_pass_template
      ? cart.total + cart.totalTax
      : cart.total,
  event,
  flex_pack: cart?.flex_pack,
  access_pass_template: cart?.access_pass_template,
  cart,
  ...(fundraisingPayload ? { fundraising: fundraisingPayload } : {}),
  ...(guest ? { guest } : {}),
})

export const createInitialFundraisingSelection = (campaign) => {
  const minimumAmount = Number(
    campaign?.donationRequirements?.minimumAmount || 0
  )
  const mandatory = Boolean(campaign?.donationRequirements?.mandatory)

  return {
    donationAmount: mandatory && minimumAmount > 0 ? minimumAmount : 0,
    anonymous: false,
    donorMessage: '',
    participantUuid: campaign?.participantUuid || '',
  }
}

export const isFundraisingDonationSatisfied = (campaign, selection) => {
  const donationAmount = Number(selection?.donationAmount || 0)
  const requirements = campaign?.donationRequirements || {}

  if (!requirements.mandatory) return true

  const minimumAmount = Number(requirements.minimumAmount || 0)
  return donationAmount >= minimumAmount
}

export const resolveCheckoutFundraisingPricing = (campaign, selection) => {
  const donationAmount = Number(selection?.donationAmount || 0)
  if (!campaign || donationAmount <= 0) {
    return EMPTY_FUNDRAISING_DONATION_PRICING
  }

  return {
    donationAmount,
    platformFee: 0,
    processingFee: 0,
    totalCharge: donationAmount,
  }
}
